import { isLifeTimeFreePlan } from "./planConstants.ts";

export const isTelegramChannel = (channel: string | null | undefined): boolean =>
  (channel ?? "").trim().toLowerCase() === "telegram";

export const canChooseAllCompanies = (
  channel: string | null | undefined,
  plan: string | null | undefined
): boolean => isTelegramChannel(channel) && !isLifeTimeFreePlan(plan);

export const coverageForDisplay = (
  channel: string | null | undefined,
  plan: string | null | undefined,
  coverage: string | null | undefined
): "watchlist" | "all" => {
  if (!canChooseAllCompanies(channel, plan)) {
    return "watchlist";
  }
  return coverage === "all" ? "all" : "watchlist";
};
